import React,{useState} from 'react'
import axios from '../../api/api'
import { toast } from 'react-toastify'

const POST_URL = '/'

const UploadFullMovie = () => {

  const [fullVideo, setFullVideo] = useState(null);
  const handleFullVideoChange = (e) => {
    setFullVideo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const formData = new FormData();
      formData.append('fullvideo', fullVideo);
      const response = await axios.post(POST_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      console.log(response);
      toast.success('Video upload success');
    } catch (error) {
      console.error(error?.response);
      toast.error('Video upload failed');
    }
  }

  return (
    <div>
      <div className="container mx-auto p-4">
        <div>
          <h2>Upload Video here</h2>
          <br />
          <form onSubmit={handleSubmit}>
            <div className='p-2'>
              <label htmlFor='type'>
                Upload Full Video: <br />
                <input
                  type='file'
                  required
                  name='fullvideo'
                  accept='video/*'
                  onChange={handleFullVideoChange}
                />
              </label>
            </div>
            <div className='p-2'>
              <button className='bg-blue-600 text-white px-5 py-1'>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default UploadFullMovie
